// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3164":"17ca63de","3178":"69ab67d8","3894":"87479a8f","5444":"996de3b8","7279":"7baec126","8508":"82bc6b9a","8812":"d59dfd74"}[chunkId] + ".chunk.css";
};